<div class="example-container" [class.example-is-mobile]="mobileQuery.matches">
    <mat-toolbar class="example-toolbar" *ngIf="mobileQuery.matches">
        <img class="hamburger" src="assets/images/menu/menu.png" (click)="snav.toggle()">
        <div class="toolbar-title">
            <h4 style="margin-bottom: 0;font-weight: 200;">Nagarajan R</h4>
            <span>Full Stack Developer</span>
        </div>
        <!-- Mobile app install icon  -->
        <img *ngIf="promptEvent" class="hamburger" src="assets/icons/add_to_home.png" (click)="installMobileApp()">
    </mat-toolbar>
    <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 50 : 0">
        <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="mobileQuery.matches"
            fixedTopGap="50" [opened]="mobileQuery.matches ? 'false' : 'true'">
            <div class="text-center p-3 nav-txt">
                <div *ngIf="!mobileQuery.matches">
                    <h2 style="margin-bottom: 0;font-weight: 200;">Nagarajan R</h2>
                    <span>Full Stack Developer</span>
                </div>
                <div class="social-icons">
                    <ng-container *ngFor="let social of socialLinks">
                        <a href="{{social.link}}" target="_blank">
                            <img src="{{social.image}}" alt="{{social.name}}">
                        </a>
                    </ng-container>
                </div>
            </div>
            <mat-nav-list (click)="mobileQuery.matches ? snav.toggle():''">
                <div id="sidebar-content">
                    <div class="menu" *ngFor="let link of menus">
                        <p #rla="routerLinkActive" routerLinkActive='active' routerLink="{{link.route}}"
                            (click)="scrollToElement(link.route)">
                            <img src="{{link.url}}"> <span>{{link.name}}</span>
                        </p>
                    </div>
                </div>
            </mat-nav-list>
        </mat-sidenav>
        <mat-sidenav-content [ngStyle]="{'padding-top': mobileQuery.matches?'20px':'0'}">
            <div class="page-content" id="about">
                <div class="content-heading">
                    <h1>About</h1>
                </div>
                <app-about></app-about>
            </div>
            <div class="page-content" id="experience">
                <div class="content-heading">
                    <h1>Experience - {{ empStrtDate | expCalcPipe:currentDate }} Yrs</h1>
                </div>
                <app-experience></app-experience>
            </div>
            <div class="page-content" id="projects">
                <div class="content-heading">
                    <h1>Projects</h1>
                </div>
                <app-projects></app-projects>
            </div>
            <div class="page-content" id="skills">
                <div class="content-heading">
                    <h1>Skills</h1>
                </div>
                <app-skills></app-skills>
            </div>
            <div class="page-content" id="education">
                <div class="content-heading">
                    <h1>Education</h1>
                </div>
                <app-education></app-education>
            </div>
            <div class="page-content" id="gallery">
                <div class="content-heading">
                    <h1>Gallery</h1>
                </div>
                <app-gallery></app-gallery>
            </div>
            <div class="page-content" id="contact">
                <div class="content-heading">
                    <h1>Contact</h1>
                </div>
                <app-contact></app-contact>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>